<template>
    <require from="../../parent-child-select/parent-child-select"></require>
    <parent-child-select
            items.bind="selectedObjectService.selectedObject.can_create_instances"
            objecttypetoadd.bind="'can_create_instance'"
            sortable.bind="'true'"
    >
    </parent-child-select>
</template>
